import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { API } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      let dest = "/";
      try {
        dest = sessionStorage.getItem("postLoginRedirect") || "/";
      } catch {}
      if (!sessionId) {
        navigate(dest, { replace: true });
        return;
      }
      try {
        const res = await fetch(`${API}/auth/session`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (!res.ok) throw new Error("auth failed");
        const u = await res.json();
        setUser(u);
      } catch (e) {
        // fall through to redirect; ProtectedRoute will handle
      } finally {
        try {
          sessionStorage.removeItem("postLoginRedirect");
        } catch {}
        // strip the hash and go to destination
        window.history.replaceState(null, "", window.location.pathname);
        navigate(dest, { replace: true });
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0F0616]">
      <div className="text-center">
        <div className="mx-auto mb-4 h-10 w-10 animate-spin rounded-full border-2 border-[#311B4D] border-t-[#D4AF37]" />
        <p className="font-serif text-xl text-[#EAD178]">Signing you in…</p>
      </div>
    </div>
  );
}
